import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CHART_ACCENT, CHART_GRID, axisTickStyle, tooltipContentStyle, tooltipLabelStyle } from './chartTheme';

const formatShortDate = (dateStr) => {
  const d = new Date(`${dateStr}T00:00:00Z`);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', timeZone: 'UTC' });
};

const SignupsChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={240}>
    <LineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
      <CartesianGrid stroke={CHART_GRID} strokeDasharray="0" vertical={false} />
      <XAxis
        dataKey="date"
        tickFormatter={formatShortDate}
        tick={axisTickStyle}
        axisLine={{ stroke: CHART_GRID }}
        tickLine={false}
        interval={Math.max(0, Math.floor((data?.length || 0) / 6) - 1)}
      />
      <YAxis allowDecimals={false} tick={axisTickStyle} axisLine={false} tickLine={false} width={30} />
      <Tooltip
        contentStyle={tooltipContentStyle}
        labelStyle={tooltipLabelStyle}
        labelFormatter={formatShortDate}
        formatter={(value) => [value, 'Signups']}
        cursor={{ stroke: CHART_GRID }}
      />
      <Line
        type="monotone"
        dataKey="count"
        stroke={CHART_ACCENT}
        strokeWidth={2}
        dot={false}
        activeDot={{ r: 4, stroke: '#000', strokeWidth: 2, fill: CHART_ACCENT }}
      />
    </LineChart>
  </ResponsiveContainer>
);

export default SignupsChart;
